import React from 'react';

import { Toast as ToastType } from '../hooks/useToast';

// Toast component props interface
interface ToastProps {
  toast: ToastType;
  onRemove: (id: string) => void;
}

// Individual toast component
export const ToastItem: React.FC<ToastProps> = ({ toast, onRemove }) => {
  const handleClick = () => {
    onRemove(toast.id);
  };

  return (
    <div
      className={`toast toast-${toast.type}`}
      onClick={handleClick}
      role='alert'
      aria-live='polite'
    >
      <div className='toast-content'>
        <span className='toast-icon'>
          {toast.type === 'error' && '❌'}
          {toast.type === 'warning' && '⚠️'}
          {toast.type === 'success' && '✅'}
          {toast.type === 'info' && 'ℹ️'}
        </span>
        <span className='toast-message'>{toast.message}</span>
      </div>
      <button
        className='toast-close'
        onClick={handleClick}
        aria-label='Close notification'
      >
        ✕
      </button>
    </div>
  );
};

// Toast container props interface
interface ToastContainerProps {
  toasts: ToastType[];
  onRemove: (id: string) => void;
}

// Toast container component
export const ToastContainer: React.FC<ToastContainerProps> = ({
  toasts,
  onRemove,
}) => {
  if (toasts.length === 0) return null;

  return (
    <div className='toast-container'>
      {toasts.map(toast => (
        <ToastItem key={toast.id} toast={toast} onRemove={onRemove} />
      ))}
    </div>
  );
};
